import './Footer.css';
import linkedIn from "../../media/Icons/linkedin.png";
import instagram from "../../media/Icons/instagram.png";
import gmail from "../../media/Icons/gmail.png";

function Footer() {

  return (
    <footer className="Footer">
      <p>© 2026 Christina Verton. All rights reserved.</p>
      <div className="social-links" id="footer-social-links">
        <a href="https://www.linkedin.com/in/christina-verton-017574257/" target="_blank" rel="noreferrer">
          <img src={linkedIn} alt="LinkedIn" />
        </a>
        <a href="https://www.instagram.com/decaying.oranges?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer">
          <img src={instagram} alt="Instagram" />
        </a>
        <a href="mailto:christinaverton04@gmail.com" target="_blank" rel="noreferrer">
          <img src={gmail} alt="Gmail" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;